import type { Api, Me, Prompt } from '../lib/api'

export type Page = {
  readonly element: HTMLElement
  readonly destroy: () => void
  /** Called when a kept-alive page is navigated away from: pause work, keep state. */
  readonly suspend?: () => void
  /** Called when a kept-alive page is shown again. */
  readonly resume?: () => void
}

export type PageContext = {
  readonly api: Api
  readonly me: Me | null
  readonly prompt: Prompt
}

/** Used when the API is unreachable so the editor still works. */
export const FALLBACK_PROMPT: Prompt = {
  text: "Draw your house. It's snowing.",
  weather: 'snow',
  intensity: 0.6,
}

export const EDIT_MEDIA = '(min-width: 768px)'
